<template>
    <span class="etapa-selo" :class="selo.classe">{{ selo.texto }}</span>
</template>

<script>
import { seloDaEtapa } from '@/utils/etapa';

export default {
    name: 'EtapaSelo',

    props: {
        passo: { type: Object, required: true },
    },

    computed: {
        selo() {
            return seloDaEtapa(this.passo);
        },
    },
};
</script>

<style scoped>
.etapa-selo {
    flex: none;
    align-self: flex-start;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    white-space: nowrap;
}

.selo--opcional {
    background: rgba(128, 128, 128, 0.16);
    color: #6b7178;
}
.selo--obrigatorio {
    background: rgba(217, 48, 37, 0.12);
    color: #c5221f;
}
.selo--ok {
    background: rgba(15, 138, 61, 0.13);
    color: #0f8a3d;
}

.theme--dark .selo--opcional { color: #b0b6bd; }
.theme--dark .selo--obrigatorio { color: #f28b82; }
.theme--dark .selo--ok { color: #5bd07f; }
</style>
